
export default function SymbolAvgPercent({id, fontSize, txtColor, overlineColor}) {
    return (<symbol id={id} viewBox="0 0 24 20">
        <text
            x={4}
            y={19}
            fontSize={fontSize??"20"}
            fill={txtColor??"black"}
        >%</text>
        <line x1={4} y1={1} x2={20} y2={1} stroke={overlineColor??"green"} strokeWidth="2" textAnchor="end" dominantBaseline="text-before-edge"/>
    </symbol>);
}